<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" style="background-color: #dbd5d5;">
    <div class="container">
      <a class="navbar-brand" href="/">Product Store Admin</a>
      <!-- <a class="navbar-brand" href="/">
          <img src="./assets/product-store-logo.jpg" class="logo" alt="">
        </a> -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/orders"
              >My Orders</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/profile"
              >Profiile</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link class="nav-link" to="/products"
              >Products</router-link
            >
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <a class="nav-link" href="#" @click.prevent="logout">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderComponent",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      window.location.reload();
    },
  },
};
</script>

<style scoped>
</style>
